import React, { useContext } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import CodeRowNumber from './CodeRowNumber';
import CodeCategoryField from './CodeCategoryField';
import CodeField from './CodeField';
import BundleIndicatorField from './BundleIndicatorField';
import CodeDescriptionField from './CodeDescriptionField';
import LegacySalePriceField from './LegacySalePriceField';
import CodeLocationField from './CodeLocationField';
import CodeUsageDetailField from './CodeUsageDetailField';
import CodeTTMField from './CodeTTMField';
import CodeMappingField from './CodeMappingField';
import RowActionsField from './CodeRowActions/RowActionsField';
import { DaylightContext } from '../../../../DaylightCodeMapper';

const displayCodeLabel = (index, values = []) =>
    index === 0 || (index % 5 === 0 && index < values.length - 1);

const formatLegacySalePrice = (codePrice) =>
    codePrice ? `$${(Math.round(codePrice * 100) / 100).toFixed(2)}` : 'n/a';

// A bundle child code row: same columns as CodeRow, shaded, with the same mapping actions.
const ChildCodeRow = ({ code, mappingIndex }) => {
    const { canFlagForReview } = useContext(DaylightContext);

    const displayUsageDetails = useSelector(
        (state) => state.daylight.userHasAccessToCodeUsageDetails,
        shallowEqual
    );
    const practiceIsFinalized = useSelector(
        (state) => state.daylight.practiceIsFinalized
    );

    const mappings = code.mappings ?? [];
    const mapping = mappings.length >= mappingIndex + 1 ? mappings[mappingIndex] : null;
    const isLabelRow = displayCodeLabel(mappingIndex, mappings);

    const codeContent = isLabelRow ? code.code : '';
    const categoryContent = isLabelRow ? code.codeCategory : ' ';
    const descriptionContent = isLabelRow ? code.codeDescription : ' ';
    const priceContent = isLabelRow ? formatLegacySalePrice(code.codePrice) : '';
    const mappingPrefix = mapping?.codeName || mapping?.taxonomyCodeNodeLabel;
    const mappingContent = mapping?.taxonomyCodeNodeLabel;

    const canDelete = mappings.length > 1;

    return (
        <tr className="border-dark bundle-child-row">
            {!practiceIsFinalized && (
                <td style={{ width: '36px', minWidth: '36px' }}>&nbsp;</td>
            )}
            <CodeRowNumber rowIndex={mappingIndex} codeRowField="" />
            <CodeCategoryField codeCategory={categoryContent} />
            <BundleIndicatorField isBundleParent={false} show={isLabelRow} />
            <CodeField content={codeContent} />
            <CodeDescriptionField codeDescription={descriptionContent} />
            <LegacySalePriceField legacySalePrice={priceContent} />
            <CodeLocationField borderTop={false} location="" />
            {displayUsageDetails && <CodeUsageDetailField content="" />}
            <CodeTTMField codeTTM="" />
            <CodeMappingField prefix={mappingPrefix} content={mappingContent} />
            <RowActionsField
                isBorderTop={mappingIndex === 0}
                canFlagForReview={canFlagForReview}
                code={code}
                mapping={mapping}
                canDelete={canDelete}
            />
        </tr>
    );
};

export default ChildCodeRow;
